export const inputStyles = { marginTop: '20px' };
export const buttonStyles = { marginTop: '10px' };
